
const DayOfWeek = {
    MONDAY: "HÉTFŐ",
    TUESDAY: "KEDD",
    WEDNESDAY: "SZERDA",
    THURSDAY: "CSÜTÖRTÖK",
    FRIDAY: "PÉNTEK",
    SATURDAY: "SZOMBAT",
    SUNDAY: "VASÁRNAP",
};

export default DayOfWeek;